var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lead-full-name d-inline-flex align-items-center" },
    [
      _vm.withLink
        ? _c(
            "router-link",
            {
              attrs: {
                to: { name: "app.leads.profile", params: { id: _vm.lead.id } }
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.lead.full_name) + "\n  ")]
          )
        : _c("span", [_vm._v("\n    " + _vm._s(_vm.lead.full_name) + "\n  ")]),
      _vm.withIcon && _vm.lead.is_blocked
        ? _c("i", { staticClass: "ml-1 text-red q-icon fa fa-ban" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }